export const documentGeneratorTranslations = {
    pt: {
        hero: {
            badge: "Gerador de Documentos",
            title: "Gere CPF e CNPJ",
            titleHighlight: "válidos gratuitamente.",
            description: "Gere documentos válidos para testes e desenvolvimento"
        },
        buttons: {
            generateCPF: "Gerar CPF",
            generateCNPJ: "Gerar CNPJ"
        },
        result: {
            cpfLabel: "CPF Gerado",
            cnpjLabel: "CNPJ Gerado",
            copySuccess: "Documento copiado para a área de transferência!",
            copyError: "Erro ao copiar documento"
        }
    },
    en: {
        hero: {
            badge: "Document Generator",
            title: "Generate CPF and CNPJ",
            titleHighlight: "valid documents for free.",
            description: "Generate valid documents for testing and development"
        },
        buttons: {
            generateCPF: "Generate CPF",
            generateCNPJ: "Generate CNPJ"
        },
        result: {
            cpfLabel: "Generated CPF",
            cnpjLabel: "Generated CNPJ",
            copySuccess: "Document copied to clipboard!",
            copyError: "Error copying document"
        }
    }
};
